// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Js_exn = require("rescript/lib/js/js_exn.js");
var $$String = require("rescript/lib/js/string.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_js_exceptions = require("rescript/lib/js/caml_js_exceptions.js");
var StringUtils$SmartcutsMacros = require("./StringUtils.bs.js");

var SearchParams = {};

function fromString(s) {
  var url;
  try {
    url = new URL(s);
  }
  catch (raw_err){
    var err = Caml_js_exceptions.internalToOCamlException(raw_err);
    if (err.RE_EXN_ID === Js_exn.$$Error) {
      var err$1 = err._1;
      if (Caml_obj.caml_equal(err$1.name, "TypeError") && Caml_obj.caml_equal(err$1.message, "Failed to construct 'URL': Invalid URL")) {
        return ;
      }
      throw err;
    }
    throw err;
  }
  return url;
}

function pathComponents(url) {
  var partsWithLeadingBlank = $$Array.of_list($$String.split_on_char(/* '/' */47, url.pathname));
  return Belt_Array.slice(partsWithLeadingBlank, 1, partsWithLeadingBlank.length);
}

function numPathComponents(url) {
  return pathComponents(url).length;
}

function sharesHostname(excludeSubdomain, urlA, urlB) {
  if (!excludeSubdomain) {
    return urlA.hostname === urlB.hostname;
  }
  var hostnameReversedPartsA = List.rev(StringUtils$SmartcutsMacros.split(".", urlA.hostname));
  var hostnameReversedPartsB = List.rev(StringUtils$SmartcutsMacros.split(".", urlB.hostname));
  if (!hostnameReversedPartsA) {
    return false;
  }
  var match = hostnameReversedPartsA.tl;
  if (!match) {
    return false;
  }
  if (!hostnameReversedPartsB) {
    return false;
  }
  var match$1 = hostnameReversedPartsB.tl;
  if (match$1 && hostnameReversedPartsA.hd === hostnameReversedPartsB.hd) {
    return match.hd === match$1.hd;
  } else {
    return false;
  }
}

var $$URL$1 = {
  SearchParams: SearchParams,
  fromString: fromString,
  pathComponents: pathComponents,
  numPathComponents: numPathComponents,
  sharesHostname: sharesHostname
};

function deriveHrefAttributeSelectorFromFullUrlAndDocumentLocation(url, $$location) {
  if ($$location.origin !== url.origin) {
    return "[href=" + (window.CSS.escape(url.toString()) + "]");
  }
  if (url.pathname.startsWith($$location.pathname)) {
    var urlMinusSharedOriginAndPath = url.toString().slice(url.origin.length + $$location.pathname.length | 0);
    var relativePath = urlMinusSharedOriginAndPath.startsWith("/") ? urlMinusSharedOriginAndPath.slice(1) : urlMinusSharedOriginAndPath;
    return "[href*=" + (window.CSS.escape(relativePath) + "]");
  }
  var urlWithoutOrigin = url.toString().slice(url.origin.length);
  return "[href=" + (window.CSS.escape(urlWithoutOrigin) + "]");
}

function normalize(baseUrl, href) {
  var baseUrlRecord = fromString(baseUrl);
  if (baseUrlRecord === undefined) {
    return "";
  }
  if (href.startsWith("/")) {
    var origin = baseUrlRecord.origin;
    return origin + href;
  }
  if (!href.startsWith("#")) {
    if (href.startsWith(".")) {
      return new URL(href, baseUrl).toString();
    } else {
      return href;
    }
  }
  var newUrlRecord = new URL(baseUrlRecord);
  newUrlRecord.hash = href;
  return newUrlRecord.toString();
}

function extractDomainName(website) {
  return website.replace(new RegExp("^(https?://)?(www\\.)?"), "").replace(new RegExp("/.*$"), "");
}

exports.$$URL = $$URL$1;
exports.deriveHrefAttributeSelectorFromFullUrlAndDocumentLocation = deriveHrefAttributeSelectorFromFullUrlAndDocumentLocation;
exports.normalize = normalize;
exports.extractDomainName = extractDomainName;
/* StringUtils-SmartcutsMacros Not a pure module */
